// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"26654":"a5937532ba4fca98","93255":"59c4d88f6395dbf6"}[chunkId] + ".css";
};